const initial = () => {
    $(".copy-to-clipboard").click(function(e){
        e.preventDefault();

        let copyText;
        if (this.hasAttribute("data-clipboard-text")) {
            let copyText = this.getAttribute("data-clipboard-text");
            copyStringToClipboard(copyText);
        } else {
            let copyText = document.getElementById('password').value;
            copyStringToClipboard(copyText);
        }

        $(this).removeClass('fa-clipboard').addClass('fa-check').delay(2000).queue(function(next){
            $(this).removeClass('fa-check').addClass('fa-clipboard');
            next();
        });
        return false;
    });
};

const copyStringToClipboard = (copyText) => {
    let el = document.createElement('textarea');
    el.value = copyText;
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}

export default initial;
